// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".imperial-setting[data-v-4aff9020] {\n  padding: 10px 60px 45px 60px;\n}\n.imperial-setting .color-save-btn[data-v-4aff9020] {\n    padding-top: 10px;\n    text-align: center;\n}\n.imperial-setting .color-save-btn .el-button[data-v-4aff9020] {\n      width: 120px;\n      background-color: #409EFF;\n      border-color: #409EFF;\n}\n", ""]);
// Exports
module.exports = exports;
